import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

// Подписывается на канал конвертации и перезагружает страницу при смене состояния,
// чтобы сервер отрисовал актуальный шаг (распознавание / подтверждение / результат).
export default class extends Controller {
  static values = { id: Number, state: String }

  connect() {
    this.consumer = createConsumer()
    this.subscription = this.consumer.subscriptions.create(
      { channel: "PalleteConvertationChannel", pallete_convertation_id: this.idValue },
      {
        received: (data) => this.handleMessage(data)
      }
    )
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  handleMessage(data) {
    if (data.type !== "state_changed") return

    if (data.error && window.Toast) {
      window.Toast.error(data.error)
    }

    if (data.state !== this.stateValue) {
      window.location.reload()
    }
  }
}
